module.exports = __webpack_public_path__ + "img/notes-and-records-the-royal-society-journal-of-the-history-of-science-cover.59cc804c.jpg";